import { render, staticRenderFns } from "./AddCotModal.vue?vue&type=template&id=6854133d&scoped=true&"
import script from "./AddCotModal.vue?vue&type=script&lang=js&"
export * from "./AddCotModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCotModal.vue?vue&type=style&index=0&id=6854133d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6854133d",
  null
  
)

export default component.exports